<script>
  import { toArray, addItem, removeItem, updateItem } from '../lib/multivalue.js';

  let { value = $bindable(''), placeholder = 'Add an item…', label = '', help = '' } = $props();

  let draft = $state('');
  let items = $derived(toArray(value));

  function add() {
    if (!draft.trim()) return;
    value = addItem(value, draft);
    draft = '';
  }

  function remove(i) {
    value = removeItem(value, i);
  }

  function edit(i, newVal) {
    value = updateItem(value, i, newVal);
  }

  function onKey(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      add();
    }
  }
</script>

<div class="mv-field">
  {#if label}<label class="mv-label">{label}</label>{/if}
  {#if help}<div class="mv-help">{help}</div>{/if}

  {#if items.length > 0}
    <ul class="mv-items">
      {#each items as item, i (i)}
        <li class="mv-item">
          <input
            class="mv-item-input"
            value={item}
            oninput={(e) => edit(i, e.target.value)}
          />
          <button class="mv-remove" onclick={() => remove(i)} type="button" aria-label="Remove">×</button>
        </li>
      {/each}
    </ul>
  {/if}

  <div class="mv-add-row">
    <input
      class="mv-add-input"
      bind:value={draft}
      placeholder={placeholder}
      onkeydown={onKey}
    />
    <button class="mv-add-btn" onclick={add} disabled={!draft.trim()} type="button">Add</button>
  </div>
</div>

<style>
  .mv-field { margin-bottom: 14px; }
  .mv-label {
    display: block;
    color: #d8d8dc;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 4px;
    letter-spacing: 0.2px;
  }
  .mv-help {
    color: #9aa0a6;
    font-size: 11px;
    margin-bottom: 8px;
    line-height: 1.4;
  }
  .mv-items {
    list-style: none;
    padding: 0;
    margin: 0 0 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .mv-item {
    display: flex;
    gap: 6px;
    align-items: stretch;
  }
  .mv-item-input {
    flex: 1;
    background: rgba(0,0,0,0.4);
    border: 1px solid rgba(255,255,255,0.08);
    color: #f4f4f6;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 13px;
    box-sizing: border-box;
    margin: 0;
    font-family: inherit;
  }
  .mv-item-input:focus {
    outline: none;
    border-color: rgba(212,175,55,0.4);
  }
  .mv-remove {
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    color: #888;
    width: 32px;
    cursor: pointer;
    border-radius: 8px;
    font-size: 16px;
    line-height: 1;
    padding: 0;
    margin: 0;
    box-shadow: none;
  }
  .mv-remove:hover {
    color: #d48484;
    border-color: rgba(212,100,100,0.3);
    transform: none;
    background: rgba(255,255,255,0.04);
  }
  .mv-add-row {
    display: flex;
    gap: 6px;
  }
  .mv-add-input {
    flex: 1;
    background: rgba(0,0,0,0.3);
    border: 1px dashed rgba(255,255,255,0.12);
    color: #f4f4f6;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 13px;
    margin: 0;
    box-sizing: border-box;
    font-family: inherit;
  }
  .mv-add-input::placeholder { color: #56565c; }
  .mv-add-input:focus { outline: none; border-color: rgba(212,175,55,0.4); border-style: solid; }
  .mv-add-btn {
    background: rgba(212,175,55,0.15);
    color: #d4af37;
    border: 1px solid rgba(212,175,55,0.3);
    padding: 0 14px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    box-shadow: none;
  }
  .mv-add-btn:hover:not(:disabled) {
    background: rgba(212,175,55,0.25);
    transform: none;
  }
  .mv-add-btn:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
